import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Popup } from '@offerzen/pinata-shame'
import { registerPopup, hidePopup as hidePopupAction, destroyPopup } from './reducers'
import { popupVisible } from './selectors'

/**
 * PopupRedux component
 *
 * @param {Object} props
 * @param {string} props.name
 * @param {string} props.title
 * @param {string} [props.theme]
 * @param {Function} [props.onPopupClose]
 * @param {boolean} [props.preventClose]
 * @param {Function} props.children
 * @param {Function} props.dispatchRegisterPopup
 * @param {Function} props.dispatchDestroyPopup
 * @param {boolean} props.visible
 * @param {Function} props.hidePopup
 *
 * @returns {JSX.Element}
 */
const PopupRedux = ({ dispatchRegisterPopup, dispatchDestroyPopup, hidePopup, visible, ...props }) => {
  const { name } = props

  useEffect(() => {
    dispatchRegisterPopup(name)

    return () => {
      dispatchDestroyPopup(name)
    }
  }, [name, dispatchRegisterPopup, dispatchDestroyPopup])

  return (
    <Popup
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      hidePopup={() => hidePopup(name)}
      visible={visible}
    />
  )
}

const mapStateToProps = (state, ownProps) => {
  const visible = popupVisible(state, ownProps.name)
  return { visible }
}

const mapDispatchToProps = {
  dispatchRegisterPopup: registerPopup,
  dispatchDestroyPopup: destroyPopup,
  hidePopup: hidePopupAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(PopupRedux)
